module.exports = __webpack_public_path__ + "img/焦作市.b4dc6909.png";